import React, { Fragment, FunctionComponent } from "react";
import NewsPageProps from "./NewsPageProps.interface";

import ContentPageBlock from "pages/ContentPage/ContentPage.block";

const NewsPage: FunctionComponent<NewsPageProps> = (props) => {
    return (
        <Fragment>
            {props.blocks?.map((blockContent, index) => {
                return (
                    <ContentPageBlock key={blockContent?.contentUdi} {...blockContent} />
                );
            })}
        </Fragment>
    );
};

export default NewsPage;